import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

import BenchlingAppCreateChoiceButton, {ButtonType} from './CreateAppChoiceButton';
import {AppOrVersion} from './CreateAppModal';

interface CreateAppChoiceButtonsProps {
  description?: string;
  appOrVersion: AppOrVersion;
  onChangeType: (button: ButtonType) => void;
}

export default function CreateAppChoiceButtons(props: CreateAppChoiceButtonsProps): JSX.Element {
  const scratchOrDraftBtnType =
    props.appOrVersion === AppOrVersion.APP ? ButtonType.FROM_SCRATCH : ButtonType.FROM_DRAFT;
  const [createType, setCreateType] = useState<ButtonType>(scratchOrDraftBtnType);
  const isFromScratch = createType === ButtonType.FROM_SCRATCH;

  function onClick(type: ButtonType): void {
    setCreateType(type);
    props.onChangeType(type);
  }

  return (
    <Col lg={4} className={css(styles.leftContainer)}>
      {props.description && <Row className={css(styles.leftCol)}>{props.description}</Row>}
      <Row className={css(styles.leftCol)}>
        <BenchlingAppCreateChoiceButton
          type={scratchOrDraftBtnType}
          isSelected={createType === scratchOrDraftBtnType}
          handleClick={onClick}
          dataTestAttrs={{
            component: 'CreateAppChoiceButtons',
            element: isFromScratch ? 'from-scratch' : 'from-draft',
          }}
        />
      </Row>
      <Row className={css(styles.leftCol)}>
        <BenchlingAppCreateChoiceButton
          type={ButtonType.FROM_MANIFEST}
          isSelected={createType === ButtonType.FROM_MANIFEST}
          handleClick={onClick}
          dataTestAttrs={{component: 'CreateAppChoiceButtons', element: 'from-manifest'}}
        />
      </Row>
    </Col>
  );
}

const styles = StyleSheet.create({
  leftCol: {
    padding: '1em',
  },
  leftContainer: {
    paddingTop: 16,
    paddingBottom: 16,
  },
});
